import styled from '@emotion/styled';
import { Text as BaseText } from '@qga/roo-ui/components';
import { color, textStyle } from 'styled-system';

const StyledErrorMessage = styled(BaseText)(textStyle, color);

const ErrorMessage = (props) => (
  <StyledErrorMessage textStyle="small" color="text.error" {...props} />
);

ErrorMessage.propTypes = StyledErrorMessage.propTypes;

export default ErrorMessage;
